'use client';

import { c as _c } from "react/compiler-runtime";
import { QuestionMarkCircle, SleeperTrainPictogram } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { Divider } from '~/components/Divider';
import type { AccommodationCardSleeperDetails } from './AccommodationCard.types';
import { ItineraryCard } from './ItineraryCard';
import type { GalleryImage } from './ItineraryCard.types';
type AccommodationCardSleeperContentProps = {
  images: GalleryImage[];
  sleeperDetails: AccommodationCardSleeperDetails;
};
export function AccommodationCardSleeperContent(t0) {
  const $ = _c(31);
  const {
    images,
    sleeperDetails
  } = t0;
  const t = useTranslations("journey");
  const {
    title,
    subheading,
    trainTimes,
    cabinLabel,
    cabinValue,
    bodyText
  } = sleeperDetails;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SleeperTrainPictogram size="small" decorative={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <ItineraryCard.Header icon={t1} title={title} />;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== images) {
    t3 = images.length > 0 ? <ItineraryCard.Gallery images={images} sliderOnly={true} /> : null;
    $[3] = images;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== subheading) {
    t4 = <ItineraryCard.Subheading>{subheading}</ItineraryCard.Subheading>;
    $[5] = subheading;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== trainTimes) {
    t5 = <ItineraryCard.TrainTimes {...trainTimes} />;
    $[7] = trainTimes;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("accommodation_sleeper_private_cabins");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <ItineraryCard.InfoBanner>{t6}</ItineraryCard.InfoBanner>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider variant="horizontal" />;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <QuestionMarkCircle size="small" decorative={true} />;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== cabinLabel || $[16] !== cabinValue) {
    t10 = <ItineraryCard.ChangeField label={cabinLabel} value={cabinValue} helpIcon={t9} onPress={_temp} />;
    $[15] = cabinLabel;
    $[16] = cabinValue;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Divider variant="horizontal" />;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== bodyText) {
    t12 = bodyText ? <ItineraryCard.Body text={bodyText} /> : null;
    $[19] = bodyText;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t10 || $[22] !== t12 || $[23] !== t4 || $[24] !== t5 || $[25] !== t7) {
    t13 = <ItineraryCard.Content>{t4}{t5}{t7}{t8}{t10}{t11}{t12}</ItineraryCard.Content>;
    $[21] = t10;
    $[22] = t12;
    $[23] = t4;
    $[24] = t5;
    $[25] = t7;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t2 || $[29] !== t3) {
    t14 = <ItineraryCard>{t2}{t3}{t13}</ItineraryCard>;
    $[27] = t13;
    $[28] = t2;
    $[29] = t3;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}
function _temp() {}